exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company-wrapper{display:flex;justify-content:flex-start;flex-wrap:wrap}.company-wrapper__image{margin:10px 10px 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ed49066","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/company/CompanyInfo.vue
// module id = 735
// module chunks = 0